export function Integrations() {
    return (
        <>
            <SEO title="Integrations - PostMgr" description="Connect PostMgr with your favorite tools and platforms" url="https://postmgr.com/integrations" />
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Integrations</h1>
                    <p className="text-xl text-gray-600">Connect with your favorite tools...</p>
                </div>
            </div>
        </>
    );
}

export default Integrations;
